/* Revival Sale Manager — opt-in cart and Recharge certification v2.2.5.
   READ ONLY: the only Shopify API request is GET /cart.js. Never modifies cart,
   product variants, Recharge, Rebuy, discounts, or checkout.
   Runs only if ?rsm_advanced_preview=1&rsm_cart_audit=1 AND the advanced
   campaign configuration is disabled. Do not use as proof of checkout totals.
*/
(function () {
  'use strict';
  var query = new URLSearchParams(window.location.search);
  if (query.get('rsm_advanced_preview') !== '1' || query.get('rsm_cart_audit') !== '1') return;
  var configNode = document.getElementById('revival-sale-advanced-config');
  var config;
  try { config = JSON.parse(configNode && configNode.textContent || 'null'); } catch (_e) { return; }
  if (!config || config.version !== 2 || config.enabled !== false || config.storefront_ready !== false) return;

  function id(value) { return String(value === undefined || value === null ? '' : value).replace(/^gid:\/\/shopify\/\w+\//, ''); }
  function cents(value) { return Number.isFinite(Number(value)) ? Number(value) : 0; }
  function money(value, currency) {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(cents(value) / 100); }
    catch (_e) { return (cents(value) / 100).toFixed(2); }
  }
  function planFromCartLine(line) {
    var plan = line && line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
    return plan && plan.id ? id(plan.id) : '';
  }
  function planFromRequest(item) { return id(item && (item.selling_plan || item.sellingPlan || '')); }
  function key(variant, plan) { return id(variant) + '|' + id(plan); }
  function units(cart) {
    var map = Object.create(null);
    (cart && cart.items || []).forEach(function (item) {
      var k = key(item.variant_id || item.id, planFromCartLine(item));
      map[k] = (map[k] || 0) + (Number(item.quantity) || 0);
    });
    return map;
  }
  function expectedUnits(items) {
    var map = Object.create(null);
    (items || []).forEach(function (item) {
      var k = key(item.id, planFromRequest(item));
      map[k] = (map[k] || 0) + (Number(item.quantity) || 0);
    });
    return map;
  }
  function compare(baseline, after, requested) {
    var before = units(baseline), now = units(after), expected = expectedUnits(requested);
    return Object.keys(expected).map(function (k) {
      var wanted = expected[k], added = (now[k] || 0) - (before[k] || 0);
      return { variant: k.split('|')[0], sellingPlan: k.split('|')[1] || null, expectedAdded: wanted, actualAdded: added, status: added >= wanted ? 'PASS' : 'CHECK' };
    });
  }
  function safeLines(cart) {
    return (cart && cart.items || []).map(function (line) {
      return {
        variantId: id(line.variant_id || line.id),
        productId: id(line.product_id),
        title: String(line.product_title || line.title || ''),
        variant: String(line.variant_title || ''),
        quantity: Number(line.quantity) || 0,
        sellingPlanId: planFromCartLine(line) || null,
        originalUnitPrice: cents(line.original_price),
        finalUnitPrice: cents(line.final_price),
        finalLinePrice: cents(line.final_line_price),
        discounts: (line.discount_allocations || []).map(function (d) {
          return { amount: cents(d.amount), source: String(d.discount_application && d.discount_application.type || 'unknown') };
        })
      };
    });
  }
  var baseline = null, lastReport = null, pending = false;
  var style = document.createElement('style');
  style.textContent = '.rsm-audit{position:fixed;z-index:2147483600;left:16px;bottom:18px;width:min(380px,calc(100vw - 32px));max-height:75vh;overflow:auto;padding:14px;border:2px solid #117a85;border-radius:12px;background:#fff;color:#193640;box-shadow:0 8px 28px #0003;font:12px/1.45 system-ui,sans-serif}.rsm-audit *{box-sizing:border-box}.rsm-audit h2{font-size:14px;margin:0 0 6px}.rsm-audit p{margin:6px 0}.rsm-audit button{background:#075a6a;color:#fff;border:0;border-radius:6px;padding:6px 9px;margin:6px 6px 0 0;cursor:pointer;font:inherit}.rsm-audit button:disabled{opacity:.5}.rsm-audit pre{white-space:pre-wrap;word-break:break-word;background:#f3f8f9;border-radius:5px;padding:8px;max-height:38vh;overflow:auto;margin:7px 0}.rsm-audit .muted{color:#607581}.rsm-audit .bad{color:#a42d2d}';
  document.head.appendChild(style);
  var panel = document.createElement('section');
  panel.className = 'rsm-audit';
  panel.setAttribute('aria-label', 'Read-only Shopify cart certification');
  panel.innerHTML = '<h2>Revival QA — cart audit (read-only)</h2><p class="muted">Actual Shopify cart, variants and selling plans. Does not place orders or change prices.</p><p class="rsm-audit-status">Capturing cart baseline...</p><button type="button" class="rsm-audit-refresh">Read Shopify cart</button><button type="button" class="rsm-audit-copy" disabled>Copy report</button><button type="button" class="rsm-audit-hide">Hide</button><pre class="rsm-audit-output">Add a one-time or subscription selection to the cart after baseline is ready.</pre>';
  document.body.appendChild(panel);
  var status = panel.querySelector('.rsm-audit-status');
  var output = panel.querySelector('.rsm-audit-output');
  var copyBtn = panel.querySelector('.rsm-audit-copy');
  function display(report) {
    lastReport = report;
    copyBtn.disabled = false;
    output.textContent = JSON.stringify(report, null, 2);
    console.info('[RevivalQA] sanitized Shopify cart report', report);
  }
  function setStatus(msg, bad) { status.textContent = msg; status.className = 'rsm-audit-status' + (bad ? ' bad' : ''); }
  function cartUrl() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/').replace(/\/?$/, '/') + 'cart.js'; }
  function fetchCart() {
    return fetch(cartUrl(), { method: 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (res) {
      if (!res.ok) throw new Error('Shopify cart HTTP ' + res.status);
      return res.json();
    });
  }
  function reportFor(cart, checks) {
    var advanced = (cart.cart_level_discount_applications || []).concat((cart.items || []).flatMap(function (x) { return x.discount_allocations || []; })).filter(function (a) {
      return /Revival Sale.{0,8}Advanced|revival-rules-discount/i.test(JSON.stringify(a));
    });
    return {
      type: 'REVIVAL_CART_AUDIT_v2.2.5',
      timestamp: new Date().toISOString(),
      currency: cart.currency,
      checkoutDiscount: 'NOT TESTED — cart.js is not checkout',
      advancedRulesEnabled: false,
      matching: checks || 'No add-to-cart event captured; showing current cart only.',
      advancedCampaignAllocationsFound: advanced.length,
      cartItemCount: cart.item_count,
      cartOriginalTotal: money(cart.original_total_price, cart.currency),
      cartTotal: money(cart.total_price, cart.currency),
      smartCartDetected: !!(window.Rebuy && window.Rebuy.SmartCart),
      lines: safeLines(cart).map(function (line) { return Object.assign({}, line, { originalUnit: money(line.originalUnitPrice, cart.currency), finalUnit: money(line.finalUnitPrice, cart.currency), lineTotal: money(line.finalLinePrice, cart.currency) }); })
    };
  }
  function inspect(requested) {
    if (pending) return;
    pending = true;
    setStatus('Reading Shopify cart...');
    fetchCart().then(function (cart) {
      var checks = requested && baseline ? compare(baseline, cart, requested) : null;
      var hasMismatch = Array.isArray(checks) && checks.some(function (x) { return x.status !== 'PASS'; });
      display(reportFor(cart, checks));
      setStatus(hasMismatch ? 'CHECK: submitted quantities or selling plans do not match cart' : (checks ? 'Cart submission verified; checkout still needs testing' : 'Shopify cart snapshot ready'), hasMismatch);
      baseline = cart;
    }).catch(function (err) { setStatus('Cart read failed: ' + err.message, true); }).finally(function () { pending = false; });
  }
  fetchCart().then(function (cart) { baseline = cart; setStatus('Baseline ready. Now click Add to Cart.'); }).catch(function (err) { setStatus('Could not capture baseline: ' + err.message, true); });
  window.addEventListener('revival:cart:confirmed', function (event) {
    var requested = event && event.detail && event.detail.items;
    if (!Array.isArray(requested) || !requested.length) return;
    // Event dispatch happens after Shopify confirms the add, before free-gift/Rebuy sync.
    setTimeout(function () { inspect(requested); }, 850);
  });
  panel.querySelector('.rsm-audit-refresh').addEventListener('click', function () { inspect(null); });
  copyBtn.addEventListener('click', function () {
    if (!lastReport) return;
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(JSON.stringify(lastReport, null, 2)).then(function () { setStatus('Sanitized report copied.'); }).catch(function () { setStatus('Could not copy; select the visible report.', true); });
  });
  panel.querySelector('.rsm-audit-hide').addEventListener('click', function () { panel.hidden = true; });
})();
